export class RestoreMicrosoft365UserRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "workloads",
            "baseName": "workloads",
            "type": "Array<Microsoft365UserRestoreWorkload>",
            "format": ""
        },
        {
            "name": "targetSaasEntityId",
            "baseName": "targetSaasEntityId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreMicrosoft365UserRequest.attributeTypeMap;
    }
    constructor() {
    }
}
